import styled from "styled-components";

export const FeatureCardContextMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: inherit;
  width: 12.5rem;
  box-sizing: border-box;
  padding: 0.5rem 0;
`;

export const DeleteFeauturesConfirmContainer = styled.div`
  strong {
    font-weight: 700;
  }
`;
